import type { PropsWithChildren, ReactNode } from 'react'

import { Cover, ResponsiveImage, coverPlaceholderSrc } from '@ds/components'

import { HERO_COVER_RESIZE, HERO_COVER_SIZES } from '../../constants/heroCover'

import styles from './AudioHeroLayout.module.css'

type TAudioHeroLayoutProps = PropsWithChildren<{
    coverUrl?: string
    /** The served template picks the branch in PHP, so it passes the whole image. */
    backgroundSlot?: ReactNode
}>

export const HeroBackground = ({ coverUrl }: { coverUrl?: string }) => (
    <ResponsiveImage
        src={coverUrl || coverPlaceholderSrc}
        alt=""
        aria-hidden
        sizes={HERO_COVER_SIZES}
        className={styles.background}
        resize={HERO_COVER_RESIZE}
    />
)

export const HeroCover = ({ src, alt }: { src: string; alt: string }) => (
    <Cover fill priority sizes={HERO_COVER_SIZES} alt={alt} src={src} resize={HERO_COVER_RESIZE} />
)

export const AudioHeroLayout = ({ coverUrl, backgroundSlot, children }: TAudioHeroLayoutProps) => (
    <div className={styles.hero} data-test="audio-hero">
        {backgroundSlot ?? <HeroBackground coverUrl={coverUrl} />}
        <div className={styles.overlay} />
        <div className={styles.layout}>{children}</div>
    </div>
)
